window.shop = window.shop || {};

shop.cacheSelectors = function () {
  shop.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#accessibleNav'),

    // Product Page
    $mainImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    newImage: null
  }
}

shop.init = function () {
  shop.cacheSelectors();
  shop.accessibleNav();
  shop.productImageSwitch();
  shop.initToggle();
  shop.initDropdowns();
  shop.initLightbox();
}

shop.initToggle = function () {
  $toggle = shop.cache.$body.find('[data-toggle=collapse]');
  $toggle.click(function(){
    shop.cache.$body.find('#' + $toggle.attr('data-target')).toggleClass('in');
  });
}

shop.initDropdowns = function () {
  $toggles = shop.cache.$body.find('[data-toggle=dropdown]');
  $toggles.click(function(e){
    e.preventDefault();
    shop.cache.$body.find($(this).next()).toggleClass('open');
    $(this).toggleClass('open');
  });
}

shop.initLightbox = function () {
  shop.cache.$body.find('.js-magnific').magnificPopup({type: 'image', gallery: { enabled: true, preload: [2,2] }, zoom: { enabled: true } });
}

shop.accessibleNav = function () {
  var $nav = shop.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul');
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav--dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      shop.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    shop.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
}

shop.productImageSwitch = function () {
  if ( !shop.cache.$thumbImages.length ) {
    return;
  }

  // Switch the main image with one of the thumbnails
  // Note: this does not change the variant selected, just the image
  shop.cache.$thumbImages.on('click', function(e) {
    e.preventDefault();
    shop.cache.newImage = $(this).attr('href');
    shop.cache.$mainImage.attr({ src: shop.cache.newImage });
  });
}

// Initialize shop's JS on docready
$(shop.init)
